module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/028-puerto-rico-b2ce68a7a82ab9df5189c0679a9cbe38.svg";